<script lang="ts" setup>
import { computed } from "vue";
import type { TripMonitorTruck } from "@/api/trips/dto/trip-monitor";
import { DAY_IN_SECONDS, HOUR_IN_SECONDS, TWENTY_MINUTES_IN_SECONDS } from "@/constants/time";
import CurrentLocationDot from "@/components/statuses/CurrentLocationDot.vue";
import type { CurrentLocationDotSettings } from "@/types/props";
import LocationIconLink from "@/components/icons/LocationIconLink.vue";

const props = defineProps<{
  truck: TripMonitorTruck | null;
}>();

const dotSettings = computed<CurrentLocationDotSettings[]>(() => {
  return [
    {
      seconds: DAY_IN_SECONDS,
      color: "grey",
    },
    {
      seconds: HOUR_IN_SECONDS,
      color: "orange",
    },
    {
      seconds: TWENTY_MINUTES_IN_SECONDS,
      color: "yellow",
    },
  ];
});
</script>

<template>
  <div>
    <div class="d-flex align-center mb-1">
      <div class="font-size-12 text-grey-darken-3 ml-2px" data-qa="truck-current-location">
        {{ props.truck?.currentLocation?.fullAddress }}
      </div>
      <location-icon-link
        v-if="props.truck?.currentLocation?.coordinates"
        :coordinates="props.truck?.currentLocation?.coordinates"
      />
    </div>
    <current-location-dot
      v-if="props.truck?.currentLocationTime"
      :dot-settings="dotSettings"
      :time="props.truck?.currentLocationTime"
      dot-class="font-size-11 text-grey-darken-2 ml-3"
      show-tooltip
    />
  </div>
</template>
